module.exports = __webpack_public_path__ + "media/images/costumes/top/swiper-wafuku-2-ea24a2c90878f2b876a0f64d3760d8b3.jpg";